/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Group_OtherInputs */

const en_cook_group_other = /** @type {(inputs: Cook_Group_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other ingredients`)
};

const de_cook_group_other = /** @type {(inputs: Cook_Group_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Zutaten`)
};

/**
* | output |
* | --- |
* | "Other ingredients" |
*
* @param {Cook_Group_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_group_other = /** @type {((inputs?: Cook_Group_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Group_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_group_other(inputs)
	return en_cook_group_other(inputs)
});